module.exports = new __parcel__URL__("waves-prevision.3ddf4c14.svg").toString();